
import React from 'react';
import { LucideIcon } from 'lucide-react';

type FeatureCardProps = {
  title: string;
  description: string;
  icon?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const FeatureCard = ({ title, description, icon, className = '', style }: FeatureCardProps) => {
  return (
    <div 
      className={`bg-white p-8 rounded-lg shadow-elegant border border-neutral-gray-200/70 hover:shadow-premium transition-all duration-300 hover:-translate-y-1 ${className}`}
      style={style}
    >
      <div className="flex flex-col items-start relative z-10">
        {icon && (
          <div className="text-primary mb-6 p-3 bg-primary/5 rounded-lg">
            {icon}
          </div>
        )}
        <h3 className="text-xl font-outfit font-semibold mb-4 text-neutral-gray-800">
          {title}
        </h3>
        <p className="text-neutral-gray-600 font-newsreader">
          {description}
        </p>
      </div>
    </div>
  );
};

export default FeatureCard;
